import SubscribeButton from '/web/shared/aifans/model/buttons/SubscribeButton'
import { Show } from 'solid-js'
import { TOKENS_RELOAD_WITH_SUBSCRIPTION } from '/common/token-plans'

const ModelPageSignupModal = (props: {
  show: boolean
  avatarUrl?: string
  subscribeToModel: () => void
  showTokensModal: () => void
  setShowSubscribeModal: (show: boolean) => void
  paymentUrl?: string
  subscribing?: boolean
}) => {
  return (
    <Show when={props.show}>
      <div
        class="fixed inset-0 z-[200] flex items-center justify-center bg-black/80"
        onClick={() => props.setShowSubscribeModal(false)}
      >
        <div
          class={`relative mx-2 w-full ${
            props.paymentUrl ? 'max-w-[560px]' : 'max-w-[900px]'
          } rounded-xl bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 p-[2px] md:mx-4`}
          onClick={(e) => e.stopPropagation()}
        >
          <div class="relative h-full w-full overflow-hidden rounded-lg bg-[#0B0F11]">
            <button
              onClick={() => props.setShowSubscribeModal(false)}
              class="absolute right-5 top-4 z-10 text-2xl text-white hover:text-white md:right-6 md:top-6 md:text-gray-400"
            >
              ✕
            </button>

            <Show
              when={!props.paymentUrl}
              fallback={
                <div class="h-[880px] max-h-[calc(100vh-140px)] w-full p-3  md:p-6">
                  <iframe
                    src={props.paymentUrl}
                    class="h-full w-full"
                    style="border: 0;"
                    allow="payment"
                  />
                </div>
              }
            >
              <div class="flex flex-col bg-model-signup-modal-gradient-mobile p-4 md:w-[700px] md:flex-row md:bg-model-signup-modal-gradient md:p-8 lg:w-[974px]">
                <div class="relative h-[280px] w-full overflow-hidden rounded-[12px] xxs:h-[322px] md:h-[400px] md:shrink-0 md:grow-0 md:basis-[335px] lg:h-[555px] lg:basis-[451px]">
                  <img class="absolute h-full w-full object-cover" src={props.avatarUrl} />
                </div>
                <div class="mt-1 md:mt-0 md:pl-10">
                  <div class="text-center text-2xl font-semibold md:flex md:flex-col md:gap-3 md:text-left md:text-[34px] lg:text-[44px]">
                    <span class="text-cosplay-pink-300">Join My </span>
                    <span class="text-white">Personal Page!</span>
                  </div>
                  <div class="flex flex-col items-center md:items-start">
                    <div class="mb-1 mt-2 text-xl md:mt-7 lg:text-[32px]">
                      <span class="font-semibold text-cosplay-pink-300 underline">VIP Option</span>{' '}
                      - <span class="text-[13px] lg:text-[15px]">$7.99/mo</span>
                    </div>
                    <div class="mb-2 flex flex-col gap-2 md:mb-11 lg:mt-4 lg:gap-4">
                      <VipOption text="UNLIMITED LIVE CHAT!" />
                      <VipOption text={`${TOKENS_RELOAD_WITH_SUBSCRIPTION} TOKEN BONUS!`} />
                      <VipOption text="FREE MONTHLY TOKENS!" />
                      <VipOption text="CUSTOM IMAGE GENERATION!" />
                      <VipOption text="ACCESS PRIVATE CONTENT!" />
                    </div>
                    <SubscribeButton
                      onSubscribe={props.subscribeToModel}
                      subscribing={props.subscribing || false}
                    />
                    <button
                      class="mt-2 text-[13px] hover:text-gray-300 md:mt-4 md:text-base"
                      onClick={props.showTokensModal}
                    >
                      No thanks, I just need tokens
                    </button>
                  </div>
                </div>
              </div>
            </Show>
          </div>
        </div>
      </div>
    </Show>
  )
}

const VipOption = (props: { text: string }) => {
  return (
    <div class="flex flex-row items-center gap-2 text-[15px] lg:gap-3 lg:text-xl">
      <img src="/images/icons/flower-check-mark.png" class="h-[15px] w-[15px] lg:h-5 lg:w-5" />{' '}
      <span class="mt-[2px]">{props.text}</span>
    </div>
  )
}

export default ModelPageSignupModal
